//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavTemplateFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.49982 12V20H1.99982V12H8.49982ZM21.9998 12V20H10.4998V12H21.9998ZM21.9998 4V10H1.99982V4H21.9998Z" fill="currentColor" /></svg>;
}
export default IconNavTemplateFill;